import { useState } from "react";
import { useFetch } from "../lib/hooks";
import { fmtDateTime } from "../lib/api";
import { PageTitle, Empty, inputCls, btnGhost } from "./ui";
import { BrandLoader } from "../components/site/Logo";

export default function AuditLogs() {
  const [page, setPage] = useState(1);
  const [action, setAction] = useState("");
  const [applied, setApplied] = useState("");
  const { data, loading } = useFetch(`/admin/audit-logs?page=${page}${applied ? `&action=${encodeURIComponent(applied)}` : ""}`);
  return (
    <div data-testid="admin-audit-page">
      <PageTitle title="Audit logovi" sub={data ? `${data.total} zapisa` : ""} />
      <form onSubmit={(e) => { e.preventDefault(); setPage(1); setApplied(action); }} className="mb-4 flex gap-2">
        <input value={action} onChange={(e) => setAction(e.target.value)} placeholder="Filter po akciji, npr. auth, article, contact" className={inputCls} data-testid="audit-filter-input" />
        <button className={btnGhost} data-testid="audit-filter-button">Filtriraj</button>
      </form>
      {loading ? <BrandLoader /> : data.items.length ? (
        <div className="overflow-x-auto rounded-lg border border-border bg-card">
          <table className="w-full text-sm" data-testid="audit-table">
            <thead className="border-b border-border bg-muted/50 text-left text-xs uppercase tracking-wider text-muted-foreground"><tr><th className="px-4 py-3">Vrijeme</th><th className="px-4 py-3">Akcija</th><th className="px-4 py-3">Korisnik</th><th className="px-4 py-3">Objekat</th><th className="px-4 py-3">Detalji</th></tr></thead>
            <tbody className="divide-y divide-border">{data.items.map((l) => (
              <tr key={l.id}>
                <td className="whitespace-nowrap px-4 py-2 text-xs text-muted-foreground">{fmtDateTime(l.created_at)}</td>
                <td className="px-4 py-2"><code className="text-xs">{l.action}</code></td>
                <td className="px-4 py-2 text-xs">{l.actor_email || "—"}</td>
                <td className="px-4 py-2 text-xs text-muted-foreground">{l.entity_type} {l.entity_id?.slice(0, 8)}</td>
                <td className="max-w-xs truncate px-4 py-2 font-mono text-[11px] text-muted-foreground">{JSON.stringify(l.details)}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      ) : <Empty testId="audit-empty">Nema zapisa.</Empty>}
      {data && data.total > 50 && (
        <div className="mt-4 flex gap-2">
          <button disabled={page <= 1} onClick={() => setPage(page - 1)} className={btnGhost} data-testid="audit-prev">←</button>
          <button disabled={page * 50 >= data.total} onClick={() => setPage(page + 1)} className={btnGhost} data-testid="audit-next">→</button>
        </div>
      )}
    </div>
  );
}
